
export const ArrowTopIcon = () => (
  <svg width="12" height="20" viewBox="0 0 12 20" fill="#8D93A1" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.29609 18.3015C5.29609 18.6881 5.60949 19.0015 5.99609 19.0015C6.38269 19.0015 6.69609 18.6881 6.69609 18.3015L5.29609 18.3015ZM6.49107 1.20334C6.2177 0.929975 5.77449 0.929975 5.50112 1.20334L1.04635 5.65811C0.772979 5.93148 0.772979 6.3747 1.04635 6.64806C1.31971 6.92143 1.76293 6.92143 2.0363 6.64806L5.99609 2.68827L9.95589 6.64806C10.2293 6.92143 10.6725 6.92143 10.9458 6.64806C11.2192 6.3747 11.2192 5.93148 10.9458 5.65811L6.49107 1.20334ZM6.69609 18.3015L6.69609 1.69832L5.29609 1.69832L5.29609 18.3015L6.69609 18.3015Z" />
  </svg>
);
